'use client';

import { Bookmark, LucideIcon } from 'lucide-react';
import Tabs from '../Tabs/Tabs';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { PROFILE_TABS, ProfileTab, toProfileTab } from '@/utils/constants';

const TAB_LABELS: Record<ProfileTab, string> = {
  downloads: 'Recently used',
  favorites: 'Favorites',
  created: 'Created',
};

const TAB_ICONS: Partial<Record<ProfileTab, LucideIcon>> = {
  favorites: Bookmark,
};

const ProfileTabs = () => {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleTabClick = (index: number) => {
    const current = new URLSearchParams(Array.from(searchParams.entries()));
    // Set tab as the first parameter
    const newParams = new URLSearchParams();
    newParams.set('tab', PROFILE_TABS[index]);

    // Add all other existing params except tab and page
    current.forEach((value, key) => {
      if (key !== 'tab' && key !== 'page') {
        newParams.append(key, value);
      }
    });

    router.push(`${pathname}?${newParams.toString()}`);
  };

  return (
    <Tabs
      tabs={PROFILE_TABS.map((tab) => {
        const Icon = TAB_ICONS[tab];
        return (
          <div key={tab} className="flex items-center gap-2">
            {Icon && <Icon size={20} className="hidden sm:block" />}
            {TAB_LABELS[tab]}
          </div>
        );
      })}
      activeTab={PROFILE_TABS.indexOf(toProfileTab(searchParams.get('tab')))}
      setActiveTab={handleTabClick}
    />
  );
};

export default ProfileTabs;
